// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"112":"e7e90f19","489":"73dcdd77","884":"59887210"}[chunkId] + ".chunk.css";
};